var _defs, _polygon, _polygon2, _ellipse, _rect, _ellipse2, _polyline, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuffsleeve01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-51,.cls-50,.cls-49{fill:#fff;}.cls-51,.cls-50,.cls-49,.cls-48{stroke:#010101;stroke-miterlimit:10;}.cls-51{stroke-width:3.07px;}.cls-50{stroke-width:1.22px;stroke-dasharray:2.44;}.cls-49{stroke-width:3.31px;}.cls-48{fill:none;stroke-width:1.86px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "265.62 447.97 229.05 399.79 323.73 339.92 351.83 392.38 265.62 447.97"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "232.6 400.43 322.82 343.39 348.61 391.55 266.19 444.69 232.6 400.43"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.18,
    cy: 416.14,
    rx: 6.26,
    ry: 6.46,
    transform: "translate(-191.73 224.71) rotate(-35.03)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 251.47,
    y: 415.47,
    width: 17.42,
    height: 1.33,
    transform: "translate(-191.73 224.71) rotate(-35.03)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.27,
    cy: 404.67,
    rx: 6.26,
    ry: 6.46,
    transform: "translate(-182.23 231.87) rotate(-35.03)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-49",
    points: "194.21 72.03 322.93 339.11 228.31 398.18 71.17 201.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "228.62 399.66 163.94 316.69 169.78 299.17 186.41 300.02 249.21 384.32 228.62 399.66"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "166.67 316.23 171.51 301.71 185.13 302.4 245.78 383.82 229.08 396.27 166.67 316.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuffsleeve01);
export default __webpack_public_path__ + "static/media/CUFF SLEEVE-01.9d064175caa1226ab5a4fe573726171f.svg";
export { ForwardRef as ReactComponent };